var sliderThumbs;
var sliderImages;

$(document).ready(function() {

    if ($('.product').length) {

        if (wSize >= 1250) {
            $('.thumbnail-slider.mobile').remove();
        }
        else {
            $('.thumbnail-slider.desktop').remove();
        }

        sliderThumbs = new Swiper(".thumbnail-slider", {
            direction: "vertical",
            slidesPerView: 7,
            spaceBetween: 10,
            speed: 500,
            navigation: {
                nextEl: ".slider-next",
                prevEl: ".slider-prev"
            },
            freeMode: true,
            watchSlidesProgress: true,
            breakpoints: {
                0: {
                    direction: "horizontal",
                    slidesPerView: 6,
                },
                1250: {
                    direction: "vertical",
                    slidesPerView: 7
                }
            }
        });

        sliderImages = new Swiper(".main-slider", {
            direction: 'horizontal',
            slidesPerView: 1,
            spaceBetween: 20,
            speed: 500,
            loop: true,
            mousewheel: false,
            navigation: {
                nextEl: ".slider-next",
                prevEl: ".slider-prev"
            },
            grabCursor: true,
            thumbs: {
                swiper: sliderThumbs
            },
            on: {
                slideChangeTransitionEnd: function () {
                    $('.float-nav button').prop('disabled', false);
                }
            }
        });

        $('.product .variants-selector.selected').each(function() {
            let variantText = $(this).text();
            $(this).prevAll('.variant-name').find('.variant-info').text(variantText);
        });

        $(document).on('click', '.product .variants-selector', function() {
            $(this).closest('.product').find('.variant-selector').removeClass('selected');
            
            $(this).addClass('selected');

            let variantText = $(this).text();
        
            $(this).prevAll('.variant-name').find('.variant-info').text(variantText);
        });
    }

    if ($('.vertical-image-slider').length) {
        $('.vertical-image-slider .owl-carousel').each(function() {
            let $carousel = $(this);

            let owl = $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: true,
                loop: false,
                autoplay: true,
                autoplayTimeout: 3000,
                smartSpeed: 800,
                margin: 20,
            });

            $(this).trigger('refresh.owl.carousel');
        });

        $('.ymal .avg').each(function() {
            let rate = $(this).find('.jdgm-prev-badge').data('average-rating');
            
            if (rate) 
                rate = parseFloat(rate).toFixed(1);
            else
                rate = '0.0';


            $(this).find('.rate').html(rate);
        });
    }

    if ($('.calculator').length) {
        $('.calculator').each(function() {
            let el = $(this);

            function calculate() {
                let I = parseFloat(el.find('#initial-investment').val()) || 0;
                let P = parseFloat(el.find('#daily-rent').val()) || 0;
                let D = parseFloat(el.find('#days-rented').val()) || 0;
                let C = parseFloat(el.find('#monthly-operating').val()) || 0;
                let G = parseFloat(el.find('#daily-power-generation').val()) || 0;
                let U = parseFloat(el.find('#daily-power-consumption').val()) || 0;
                let E = parseFloat(el.find('#electricity-price').val()) || 0;
            
                let output_1 = P * D;
                let output_2 = Math.min(G, U) * E;
                let output_3 = output_1 + (output_2 * 30);
                let output_4 = output_3 - C;
            
                let output_5 = output_4 > 0 ? (I / output_4).toFixed(2) : "N/A"; 
            
                el.find('[data-output="1"]').html('$' + output_1.toLocaleString());
                el.find('[data-output="2"]').html('$' + output_2.toLocaleString());
                el.find('[data-output="3"]').html('$' + output_3.toLocaleString());
                el.find('[data-output="4"]').html('$' + output_4.toLocaleString());
                el.find('[data-output="5"]').html(output_5 !== "N/A" ? output_5 + ' month/s' : 'No Payback');
            }
                  

            el.find('.range-input').each(function() {
                let $range = $(this).find('input[type="range"]');
                let $tip = $(this).find('.tip');
                let $tip_m = $(this).prev('.text').find('.tip-mobile');

                function updateProgress() {
                    let progress = ($range.val() - $range.attr('min')) / ($range.attr('max') - $range.attr('min')) * 100;
                    $range.css('--progress', progress + '%');

                    let val = $range.val();

                    if ($tip.hasClass('money')) {
                        val = '$' + parseFloat(val).toLocaleString();
                    }

                    $tip.text(val);
                    $tip.css('--progress', progress + '%');

                    $tip_m.text(val);
                }
    
                $range.on('input', function() {
                    updateProgress();
                    calculate();
                });

                updateProgress();
            });

            if (wSize >= 1250) {
                let spans = el.find('.range span');
                let maxWidth = 0;
                spans.each(function() {
                    let width = $(this).outerWidth();
                    if (width > maxWidth) {
                        maxWidth = width;
                    }
                });
                spans.width(maxWidth);
            }

            calculate();
        });
    }

    if ($('.ymal').length) {
        $('.ymal .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            let owl = $carousel.owlCarousel({
                items: 3,
                nav: false,
                dots: false,
                loop: true,
                smartSpeed: 800,
                margin: 20,
                stagePadding: 50,
                responsive: {
                    0: {
                        items: 1,
                        stagePadding: 0,
                        dots: true
                    },
                    768: {
                        items: 2,
                        stagePadding: 20,
                        dots: true
                    },
                    1250: {
                        items: 3,
                        stagePadding: 50,
                        dots: false
                    }
                }
            });

            let img_h = $carousel.find('.product-image').height() / 2;
            let btn_h = $floatNav.find('button').height() / 2;
            $floatNav.css('top', `${img_h+btn_h}px`);

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });

            $(this).trigger('refresh.owl.carousel');
        });

        $('.ymal .avg').each(function() {
            let rate = $(this).find('.jdgm-prev-badge').data('average-rating');
            
            if (rate) 
                rate = parseFloat(rate).toFixed(1);
            else
                rate = '0.0';


            $(this).find('.rate').html(rate);
        });
    }
    
    vertical_image_slider();
    product_nav();

});

$(window).scroll(function() {

    vertical_image_slider();
    product_nav();

});

let faqCount = 5;
$('.faq .faq-load').on('click', function () {
    const $button = $(this);
    const $spanFirst = $button.find('span:first-child');
    const $spanLast = $button.find('span:last-child');
    const $items = $('.faq .accordion-item');
    const $faq = $('.faq');

    if ($button.hasClass('show-less')) {
        faqCount = 5;
        $items.hide().slice(0, faqCount).fadeIn();
        $button.removeClass('show-less').addClass('load-more');
        $spanFirst.show();
        $spanLast.hide();
        /* $('html, body').animate({
            scrollTop: $faq.offset().top - 100
        }, 0); */
    } else {
        faqCount += 5;
        $items.slice(0, faqCount).fadeIn();

        if (faqCount >= $items.length) {
            $button.removeClass('load-more').addClass('show-less');
            $spanFirst.hide();
            $spanLast.show();
        }
    }
});

function vertical_image_slider() {
    $('.vertical-image-slider').each(function () {
        let el = $(this);

        let $images = $(this).find('.wrapper .images');

        if ($(this).find('.wrapper').data('size') == 1) {
            $(this).find('.wrapper').css('height', '100vh');
        }
        if ($(this).find('.wrapper').data('size') == 2) {
            $(this).find('.wrapper').css('height', '160vh');

            let scrolled = visiblePercent(el) * 1.6;

            if (scrolled >= 120) {
                $images.find('img:nth-child(1)').css({
                    'opacity': '1',
                });
                $images.find('img:nth-child(2)').css({
                    'opacity': '1',
                });
            }
            else {
                $images.find('img:nth-child(1)').css({
                    'opacity': '1',
                });
                $images.find('img:nth-child(2)').css({
                    'opacity': '0%',
                });
            }
        }
        if ($(this).find('.wrapper').data('size') == 3) {
            $(this).find('.wrapper').css('height', '200vh');

            let scrolled = visiblePercent(el) * 2;

            if (scrolled >= 120 && scrolled < 160) {
                $images.find('img:nth-child(1)').css({
                    'opacity': '1',
                });
                $images.find('img:nth-child(2)').css({
                    'opacity': '1',
                });
                $images.find('img:nth-child(3)').css({
                    'opacity': '0',
                });
            }
            else if (scrolled >= 160) {
                $images.find('img:nth-child(1)').css({
                    'opacity': '1',
                });
                $images.find('img:nth-child(2)').css({
                    'opacity': '1',
                });
                $images.find('img:nth-child(3)').css({
                    'opacity': '1',
                });
            }
            else {
                $images.find('img:nth-child(1)').css({
                    'opacity': '1',
                });
                $images.find('img:nth-child(2)').css({
                    'opacity': '0',
                });
                $images.find('img:nth-child(3)').css({
                    'opacity': '0',
                });
            }
        }
    });
}

$('.configuration .btn').on('click', function() {
    let status = parseInt($(this).attr('data-status')) || 0;
    let row = $(this).closest('.row').prevAll('.row-table').first();

    if (status === 1) {
        row.closest('.configuration').find('.row-table > div').show();
        $(this).attr('data-status', '0');
    } else {
        row.closest('.configuration').find('.row-table > div:nth-child(n+5)').hide();
        $(this).attr('data-status', '1');

        /* let target = row.closest('.configuration').find('.row-table > div:nth-child(1)').first();
        $('html, body').animate({
            scrollTop: target.offset().top - 200
        }, 0); */
    }

    $(this).find('span:first-child').toggle();
    $(this).find('span:last-child').toggle();
});

function product_nav() {
    if ($('.product-nav').length) {
        if (visiblePercent($('footer')) > 0)
            $('.product-nav').fadeOut();
        else
            $('.product-nav').fadeIn();
    }
}